<template>
	
<core-card-foot-item v-if="!isUser">

	<core-divisive :score="item.users.divisiveness" :count="item.users.totalRatings" />

	<core-card-foot-item-label>{{ field.label }}</core-card-foot-item-label>

</core-card-foot-item>

</template>

<script>

export default {

	props: ['item', 'field']

}

</script>

<style scoped>

</style>
